module.exports = __webpack_public_path__ + "img/five-cover.1cb8c79a.png";